import { IntegrationType, FullAudit, IsActiveFlag, LevelModel } from '@/types';

export interface IntegrationModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    level: LevelModel;
    type: IntegrationType;
}
